var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"notifications"},[_c('transition-group',{attrs:{"name":"list","tag":"div"}},_vm._l((_vm.notificationList),function(data,index){return _c('notification',{key:data.id,attrs:{"notification-data":data},on:{"close-notification":function($event){return _vm.closeNotification($event, index)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }